/**
 * Is a layer on screen at the given clip-time playhead?
 *
 * Half-open `[start, end)`, matching the Remotion `<Sequence>` that renders it
 * (`from = start * fps`, `durationInFrames = (end - start) * fps`). Used to
 * hide the canvas transform handles of layers that aren't currently visible —
 * otherwise you could select and drag a layer you cannot see.
 */
export function isLayerVisibleAtClipTime(
  layer: { start: number; end: number },
  clipTime: number,
): boolean {
  return clipTime >= layer.start && clipTime < layer.end;
}
